<template>
  <div class="container" v-if="this.datosRegistro != null">

    <aside class="bg-primary bg-gradient rounded-1 p-0 p-sm-1 mt-1">
      <div
          class="d-flex align-items-center justify-content-between flex-column flex-xl-row text-center text-xl-start">
        <div class="mb-4 mb-xl-0">
          <div class="fs-3 fw-bold text-white">
            <span v-if="this.datosRegistro.id==null">Registrar Nuevo Permiso</span>
            <span v-else>Editar Permiso</span>
          </div>
        </div>
      </div>
    </aside>

    <div class="row">
      <div class="col-md-8">
        <span class="text">Permiso:</span>
        <input v-model="datosRegistro.permiso" maxlength="200" class="m-4" type="text" placeholder="Nombre del permiso">
      </div>
      <div class="col-md-4">
        <span class="text">Código:</span>
        <input v-model="datosRegistro.codigo" maxlength="50" class="m-4" type="text" placeholder="Código del permiso">
      </div>
    </div>
    <div class="row">
      <div class="col" align="center">
        <button class="btn btn-success " @click="registrar()">Guardar</button>
      </div>
      <div class="col" align="center">
        <button class="btn btn-danger " @click="cancelar()">Cancelar</button>
      </div>
    </div>
  </div>
</template>

<script>
import {inject} from "vue";
import {PermisosService} from "@/services/PermisosService";

export default {
  components: {},

  inject: ['$axios', '$localStorageService'],
  setup() {
    return {
      srv_PermisoService: new PermisosService(inject('$axios'))
    }
  },
  props: {
    original: Object
  },
  data() {
    return {
      datosRegistro: {
        id: null,
        permiso: null,
        codigo: null
      },
    }
  },
  mounted() {
    if (this.original != null && this.original.id != null) {
      this.obtener();
    }
  },
  methods: {
    async obtener() {

      let load = this.$loading.show({
        container: this.$refs.formContainer,//puede ponerse null
        canCancel: false,
        onCancel: this.onCancelLoader,
      });

      await this.srv_PermisoService.obtener({nombre: ""+this.original.id}).then((response) => {
        if (response != null && response.length > 0) {
          this.datosRegistro = response[0];
        }
      }).catch((error) => {
        console.error(error)
        this.$swal(error.message);
      }).finally(() => load.hide());
    },
    async registrar() {
      let load = this.$loading.show({
        container: this.$refs.formContainer,//puede ponerse null
        canCancel: false,
        onCancel: this.onCancelLoader,
      });

      await this.srv_PermisoService.registro(this.datosRegistro).then((res) => {
        this.$swal(res.msj);
        this.cancelar();
      }).catch((error) => {
        console.error(error)
        this.$swal(error.message);
      }).finally(() => load.hide());
    },
    cancelar() {
      this.$emit('_cancelarEditar');
    }
  }
}
</script>

<style scoped>

</style>